<template>
  <div class="rui-list-item" :class="componentCSS">
    <div v-if="$slots.left" class="rui-list-item__actions">
      <rui-toolbar>
        <!-- @slot Left toolbar content -->
        <slot name="left" />
      </rui-toolbar>
    </div>

    <div class="rui-list-item__content" @click="$emit('choose')">
      <img v-if="image" :src="image" alt="">
      <rui-icon v-else-if="icon" :name="icon" />

      <component :is="componentTag" v-bind="componentProps" role="button" class="rui-list-item__title">
        <!-- @slot Default slots, replaces `caption` prop -->
        <span><slot>{{ caption }}</slot></span>
        <span v-if="subCaption || $slots.subCaption" class="-text--small">
          <slot name="subCaption">{{ subCaption }}</slot>
        </span>
      </component>
    </div>

    <div v-if="$slots.right" class="rui-list-item__actions">
      <rui-toolbar>
        <!-- @slot Right toolbar content -->
        <slot name="right" />
      </rui-toolbar>
    </div>
  </div>
</template>

<script>
import RuiIcon from '../Icon/Icon.vue'
import RuiToolbar from '../Toolbar/Toolbar.vue'

/**
 * Small one line item to use in lists
 *
 * @preset Default { "props": { "caption": "My item" } }
 * @propsGroup Display [inline]
 * @propsGroup State   [active, static]
 * @propsGroup Content [icon, image, caption, subCaption, to]
 */
export default {
  name: 'RuiListItem',
  emits: [
    'choose',
  ],
  components: { RuiToolbar, RuiIcon },
  props: {
    /** Icon name */
    icon: { required: false, type: String, default: null },
    /** Image URL. Overrides `icon` */
    image: { required: false, type: String, default: null },
    /** Main text */
    caption: { required: false, type: String, default: null },
    /** Secondary text */
    subCaption: { required: false, type: String, default: null },
    /** Whether the item is selected */
    active: { required: false, type: Boolean, default: false },
    /** Whether to give the impression the item is not clickable */
    static: { required: false, type: Boolean, default: false },
    /** Whether to display the title and subtitle on the same line */
    inline: { required: false, type: Boolean, default: false },
    /** Vue-router route. Item will be a link when used */
    to: { required: false, type: [Object, String], default: null },
  },
  computed: {
    componentCSS () {
      return [
        this.active && 'rui-list-item--active',
        this.static && 'rui-list-item--static',
        this.inline && 'rui-list-item--inline',
        (this.subCaption || this.$slots.subCaption) && 'rui-list-item--has-sub-caption',
      ]
    },
    componentTag () {
      if (!this.to) return 'a'

      return 'RouterLink'
    },
    componentProps () {
      if (!this.to) return {}

      return {
        to: this.to,
      }
    },
  },
}
</script>
